import { ChecklistItem } from "@reside/reside-api-admission";
const { CheckedStatusEnum } = ChecklistItem;
export { CheckedStatusEnum };
